export const environment = {
  production: false,
  apiBaseUrl: "https://qaapi-deathverifier.leadcruncher.com"
};
